import PensionKlatpensionCalculationInfoDialog from './PensionKlatpensionCalculationInfoDialog';

export default PensionKlatpensionCalculationInfoDialog;
